<template>
  <div
    class="text"
    :class="{'html': html}"
  >
    <div
      v-if="html"
      class="content"
      :class="{
        'is-cut': !expanded,
      }"
      v-html="text"
    />
    <template v-else>
      {{ preparedText }}
    </template>
    <a
      v-if="showBtn"
      class="expand"
      href="#"
      @click.prevent="toggle"
    >
      {{ expanded ? 'Hide' : 'Read more' }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'read-more-text',
  props: {
    text: {
      type: String,
      default: '',
    },
    html: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shortTextLength: 90, // max words in text
      wordsGap: 20, // do not hide less than 20 words
      expanded: false,
      showBtn: true,
    };
  },
  computed: {
    preparedText() {
      const textArray = this.text.split(' ');
      if (textArray.length < this.shortTextLength + this.wordsGap || this.expanded) {
        return this.text;
      }
      return textArray.slice(0, this.shortTextLength).join(' ');
    },
  },
  mounted() {
    if (!this.html && (this.text.split(' ').length < this.shortTextLength + this.wordsGap)) {
      this.showBtn = false;
    }
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped lang="scss">
.text {
  color: #6e7c91;
  font-size: 12px;
  line-height: 16px;
  &.html {
    .content {
      &.is-cut {
        overflow: hidden;
        max-height: 48px;
      }
    }
  }
  @media screen and (min-width: 1025px) {
    font-size: 14px;
    line-height: 20px;
    &.html .content.is-cut {max-height: 100px;}
  }
}
.expand {
  color: #6e7c91;
  font-size: 12px;
  font-weight: 700;
  @media screen and (min-width: 1025px) {
    font-size: 14px;
  }
}
</style>
